'use client';

import { Dialog, styled } from '@mui/material';

import { DialogSize } from './types';

const getWidth = (size: DialogSize) => {
  if (size === 'small') {
    return 360;
  }

  if (size === 'medium') {
    return 480;
  }

  return 640;
};

export const StyledDialog = styled(Dialog)<{ size: DialogSize }>(
  ({ size, theme }) => ({
    '& .MuiDialog-paper': {
      position: 'relative',
      maxWidth: getWidth(size),
      width: getWidth(size),
      borderRadius: theme.spacing(2),
    },
  }),
);
